type PaymentErrors = { [key: string]: string[] } | undefined;

/**
 * The reason a charge was refused, out of the flat `{ path: messages[] }` map the payment store
 * holds after a 422 — the first message, or the path that carries no message.
 */
export const resolvePaymentFailureReason = (errors: PaymentErrors = {}): string | undefined => {
  const entry = Object.entries(errors)[0];

  if (!entry) {
    return undefined;
  }

  const [key, messages] = entry;

  return messages?.[0] ?? key;
};
